const fromdata = [
  {
    inputdata: "",
    title: "文件名称",
    fontSize: "14px",
    color: "#333333",
    placeholder: "请输入",
    types: "text",
    inputtype: "input",
    width: "210px",
  },
];
export default fromdata;
